import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';

export const useEnableArcadeGameList = () => {
  const {
    flags: { enableGameListOnArcadeBoard = false },
  } = useFeatureFlags();

  return enableGameListOnArcadeBoard;
};
